import { render, staticRenderFns } from "./GlobalSettingsPanel.vue?vue&type=template&id=22a29584&"
import script from "./GlobalSettingsPanel.vue?vue&type=script&lang=ts&"
export * from "./GlobalSettingsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSettingsPanel.vue?vue&type=style&index=0&id=22a29584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports